import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { ORDEN_FINANCIERO_CONTENT, trackEventOnce } from './utils/pixel';
const META_PIXEL_ID = '1374426524177378';
// Meta Pixel Code
!function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
(window as any).fbq('init', META_PIXEL_ID);
// PageView: once per page load
trackEventOnce('PageView');
render(<App data-id="element-227" data-mp="2tzwllklx1o6c" />, document.getElementById('root'));
// ViewContent: once, after the main content has been mounted and painted
if (typeof window !== 'undefined') {
  window.requestAnimationFrame(() => {
    trackEventOnce('ViewContent', ORDEN_FINANCIERO_CONTENT);
  });
}